export const reviewPageSizeOptions: [number, ...Array<number>] = [10, 25, 50, 100];
export const MAX_ROWS_TEXTAREA = 3;
export const MIN_ROWS_TEXTAREA = 1;
